import axios from 'axios';
import API_ROUTES from '../api';

export const syncProfileToLocalStorage = (data = {}) => {
    localStorage.setItem('email', data.email || '');
    localStorage.setItem('realName', data.realName || '');
    localStorage.setItem('org', data.org || '');
    localStorage.setItem('mobile', data.mobile || '');
    localStorage.setItem('status', data.status ?? '');
    localStorage.setItem('manage', data.manage ?? '');
    localStorage.setItem('auditReminded', data.auditReminded ?? 0);
    localStorage.setItem('studentCertificate', data.studentCertificate || '');
    return data;
};

export const refreshCurrentProfile = () => {
    // 进入受限页面前刷新服务端账号状态，避免使用登录时写入的过期 localStorage 状态
    return axios.get(API_ROUTES.api_profile, {
        headers: {
            Authorization: localStorage.getItem('userInfo'),
        },
    }).then((response) => {
        if (response.data.code !== 200) {
            throw new Error(response.data.msg || 'Failed to refresh profile.');
        }
        return syncProfileToLocalStorage(response.data.data);
    });
};
